var _rect, _rect2, _g, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDpageComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_405_32250",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 18,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_405_32250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.5H15.5V14H9.5V15.5ZM9.5 13.25H18.5V11.75H9.5V13.25ZM9.5 11H18.5V10.925C18.0375 10.825 17.6156 10.6531 17.2344 10.4094C16.8531 10.1656 16.525 9.8625 16.25 9.5H9.5V11ZM6.5 21.5V8C6.5 7.5875 6.64688 7.23438 6.94063 6.94063C7.23438 6.64688 7.5875 6.5 8 6.5H15.575C15.525 6.75 15.5 7 15.5 7.25C15.5 7.5 15.525 7.75 15.575 8H8V17.8438L8.8625 17H20V10.925C20.2875 10.8625 20.5563 10.7781 20.8063 10.6719C21.0563 10.5656 21.2875 10.425 21.5 10.25V17C21.5 17.4125 21.3531 17.7656 21.0594 18.0594C20.7656 18.3531 20.4125 18.5 20 18.5H9.5L6.5 21.5ZM19.25 9.5C18.625 9.5 18.0938 9.28125 17.6562 8.84375C17.2188 8.40625 17 7.875 17 7.25C17 6.625 17.2188 6.09375 17.6562 5.65625C18.0938 5.21875 18.625 5 19.25 5C19.875 5 20.4062 5.21875 20.8438 5.65625C21.2812 6.09375 21.5 6.625 21.5 7.25C21.5 7.875 21.2812 8.40625 20.8438 8.84375C20.4062 9.28125 19.875 9.5 19.25 9.5Z",
    fill: "#1C1B1F"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#FFDF0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpageComment);
export default __webpack_public_path__ + "static/media/dpage_comment.88d75f575915c9f5c5bbe2a698d16d33.svg";
export { ForwardRef as ReactComponent };